import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILink from 'UIComponents/link/UILink';
import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import { FEATURED_CALLOUT_LAYOUT_TYPES } from 'marketplace-ui-common/callouts/constants/FeaturedCallouts';
import CoreFeaturedCallout from 'marketplace-ui-common/callouts/components/FeaturedCallout';
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import { getThemesStorefrontRoute } from '../../utils/urls';
import { fetchCallouts, selectCallouts } from '../../slices/callouts/calloutsSlice';
import { selectCollections } from '../../slices/collections/collectionsSlice';

function FeaturedCallout({
  callout,
  layout,
  onTrackInteraction
}) {
  const {
    id,
    publishedListing
  } = callout;
  const {
    collectionId,
    externalUrl
  } = publishedListing;
  const collections = useSelector(selectCollections);
  const collection = collections.find(c => c.id === collectionId);
  const LinkComponent = collection ? UIRouterLink : UILink;
  const link = collection && collection.publishedListing ? getThemesStorefrontRoute(collection.publishedListing.slug) : externalUrl;
  if (!link) return null;
  return /*#__PURE__*/_jsx(CoreFeaturedCallout, {
    buttonText: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.buttonText,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.buttonText`
    }),
    description: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.description,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.description`
    }),
    headline: /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.headline,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.headline`
    }),
    gradientColor: publishedListing.gradientColor,
    illustrationName: publishedListing.illustration,
    layout: layout,
    Link: LinkComponent,
    linkProps: collection ? {
      to: link
    } : {
      href: link
    },
    onClick: () => {
      onTrackInteraction('click featured callout', {
        section: `featured-callout::${id}::static`
      });
    },
    external: !collection,
    responsive: true
  });
}

export default function CalloutsSection({
  onTrackInteraction
}) {
  const dispatch = useDispatch();
  const callouts = useSelector(selectCallouts);
  const isMobile = useIsMaxScreenSize('sm');
  useEffect(() => {
    dispatch(fetchCallouts()).catch(error => console.error('Error fetching callouts', error));
  }, [dispatch]);
  if (callouts.length === 0) return null;
  const isSingleColumn = isMobile || callouts.length === 1;
  const columns = isSingleColumn ? 1 : 2;
  const layout = isSingleColumn ? FEATURED_CALLOUT_LAYOUT_TYPES.FULL_WIDTH : FEATURED_CALLOUT_LAYOUT_TYPES.MULTI;
  return /*#__PURE__*/_jsx(UICardGrid, {
    columns: columns,
    className: "p-top-8 m-top-8 p-bottom-0",
    children: callouts.map(callout => /*#__PURE__*/_jsx(FeaturedCallout, {
      callout: callout,
      layout: layout,
      onTrackInteraction: onTrackInteraction
    }, callout.id))
  });
}